import { stat } from 'fs';
export class Constants{
    static readonly INCIDENTS = 'v1/incident/incidents';
    static readonly INCIDENTS_BY_EVENT = 'v1/incident/incident-by-event-id';
    static readonly LASTES_ALERTS = 'v1/incident/latest-alerts';
    static readonly INCIDENTS_TYPES = 'v1/incident/incident-types'
     static readonly USED_INCIDENTS_TYPES = 'v1/incident/fecth-used-event-types'
    static readonly SITES = 'v1/incident/sites'
    static readonly INCIDENT_STATUS = 'v1/incident/incident-status'
    static readonly GENERIC_ATTRIBUTE_VALUE = 'v1/incident/attribute-value'
    static readonly LOCALE_CODE = 'localeCode'
    static readonly LOCALE_CODE_OLD = 'locale_code'
    static readonly ATTRIBUTE_TYPE = 'AttributeTypeIds'
    static readonly SAVE_INCIDENT = 'v1/incident/save-incidents'
    static readonly REJECT_INCIDENT = 'v1/incident/reject-incidents'
    static readonly SITES_ID = 'sites'
    static readonly DEVICES='devices'
    static readonly DEVICES_MANAGEMENT = 'v1/device-management'
    static readonly DEVICES_SOURCES = 'v1/device-management/GetSourcesDevices'
    static readonly CATALOGE_GET_DEVICES_SOURCES = 'v1/CatalogeOfDevices/GetCatalogeSourcesDevices'
    static readonly GET_CLIENTS= 'v1/CatalogeOfDevices/GetClientsByUsername'
    static readonly GET_LOCATIONS = 'v1/CatalogeOfDevices/GetLocationsBySite' 
    static readonly POST_SAVE_DEVICE = 'v1/CatalogeOfDevices/SaveDevice'
    static readonly POST_DELETE_DEVICE = 'v1/CatalogeOfDevices/DeleteSourceDevice'
    static readonly SAVE_REPORT_FIELDS = 'v1/service-device'
    static readonly SAVE_MONITORING_PERFORMANCE = 'PerformanceMonitoring/UpdatePerformanceMonitoring'
    static readonly GET_DEVICE_SERVICE_REVIEW = 'v1/service-device/FieldServiceDevices'
    static readonly GET_PERFORMANCE_MONITORING = 'PerformanceMonitoring/GetPerformanceMonitoring'
    static readonly UPDATE_REPORT_FIELDS = 'v1/service-device/SaveFieldServiceDevices'
    static readonly GET_LANDING_PAGE = 'v1/ladingPage'
    static readonly GET_SITES_FOR_LANDING_PAGE = 'v1/ladingPage/GetSitesForLandigPage'
    static readonly GET_AVAILABILITY_DEVICES = 'v1/DevicesAvailability'
    static readonly EVENT_IMAGES = 'v1/files/Images';
    static readonly LASTES_ALERTS_IMAGES = 'v1/files/ImageEvents';
    static readonly EVENT_ID = 'EventId'
    static readonly FILE = 'file'
    static readonly SAVE_CONFIGURATION_ALERT = 'v1/configuration-alert/SaveConfigurationAlert'
    static readonly VALIDATE_SEVERITY_EVENT = 'v1/configuration-alert/GetIsValidSeverityEventAlerts'
    static readonly GET_NOTIFIATION_CONTIGURATION = 'v1/NotificationConfiguration/GetNotificationsConfigurations'
    static readonly GET_CONTACS = 'v1/Contacs/GetAllContacs'
    static readonly SAVE_CONFIGURATION_ALERT_DETAIL = 'v1/configuration-alert/SaveConfigurationAlertDetail'
    static readonly siteId = 'siteId'
    static readonly sourceDeviceId = 'sourceDeviceId'
    static readonly GET_DETAIL_CONFIGURATION_ALERT = 'v1/configuration-alert/GetConfigurationAlertByDeviceId'
    static readonly SAVE_STOP_ALERT = 'v1/configuration-alert/SaveStopAlertDevices'

    static readonly NAME_WHATSAPP = "WHATSAPP"
    static readonly NAME_EMAIL= "EMAIL"
    static readonly NAME_STROBE_SIREN = "STROBE SIREN"
    static readonly NAME_SPEAKER= "SPEAKER"
    static readonly NAME_I4="I4Safety Notification"
    static readonly GET_CONFIGURATIONS_ALERTS = "v1/configuration-alert/GetConfigurationsAlertsByDevice"
    static readonly eventTypeId = "eventTypeId"
    static readonly severityTypeId = "severityTypeId"
    

     static readonly NOTIFICATIONS_BY_SITE = 'v1/NotificationConfiguration/GetNotificationsBySite'
     static readonly API_NAME = 'api'
     static readonly GET_AUTH_TOKEN = 'v1/Token'

     static readonly GET_STORAGE_API_BY_PARAM_BY_SITE_OR_DEFAULT = 'v1/configParams/GetStorageApiParamBySiteOrDefault'
     static readonly GET_EVENTS_FILE_NAMES = 'v1/files/GetEventsFileNames'
     static readonly STREAMING_BLOB = 'v1/files/StreamingBlob/';

     //ALERT_NOTIFICATION
     static readonly GET_SOURCE_DEVICES_BY_TYPE = 'v1/configuration-alert/GetSourceDevicesByType';
     static readonly GET_SOURCE_DEVICE_ALERT_BY_SOURCE_DEVICE_ID = 'v1/configuration-alert/GetSourceDeviceAlertsBySourceDeviceId';
     static readonly GET_SOURCE_DEVICE_ALERT_NOTIFICATION_BY_ALERT_ID = 'v1/configuration-alert/GetSourceDeviceAlertNotificationByAlertId';
     static readonly GET_CONTACTS_BY_SITE = "v1/configuration-alert/GetContactsBySite"
     static readonly GET_ALERT_TYPES = "v1/configuration-alert/GetAlertTypes"
     static readonly GET_NOTIFICATIONS_CONFIGURATION = "v1/configuration-alert/GetNotificationsConfiguration"
     static readonly SAVE_ALERT_NOTIFICATION = "v1/configuration-alert/SaveAlertNotification"
     static readonly SAVE_SOURCE_DEVICE_ALERT = "v1/configuration-alert/SaveSourceDeviceAlert"
     static readonly GET_EVENT_TYPES = "v1/configuration-alert/GetEventTypes"
     static readonly DELETE_SOURCE_DEVICE_ALERT = "v1/configuration-alert/DeleteSourceDeviceAlerts"
     static readonly DELETE_ALERT_NOTIFICATION = "v1/configuration-alert/DeleteAlertNotification"

    //SanityCheck
   static readonly GET_SANITY_CHECK = "v1/sanity-check"

     
     
    }